import * as React from 'react'; 
import { any, bool, func, string, shape, oneOf, array, arrayOf, number, oneOfType } from 'prop-types';

import Button from '../Button';
import HabitItem from '../HabitItem';
import {HABIT_TYPE} from '../../features/Habit/constants';

export default function HabitCard({habit, onMarkComplete, onUndoComplete}){

  let { 
     color, 
     type, 
     id, 
     uuid, 
     recurrence, 
     completed, 
     name 
  } = habit;

  if(!color) color = 'red-400'

  const handleComplete = _ => {
    onMarkComplete(habit);
  }

  const handleUndo = e => {
    e.preventDefault();
    onUndoComplete(habit);
  }

  if(!completed){
    return <div className={`border-${color} border-l-4 shadow rounded w-full lg:w-56 p-2 mb-5 bg-white`}>
        <h4 className="text-lg mb-5">
          <HabitItem habit={habit}/>
        </h4>
       
       <Button fitContainer onClick={handleComplete}> {type === HABIT_TYPE.DO ? "Mark complete" : "I avoid it"} </Button>
      </div>
  }

   return (
     <div className={`bg-${color} w-full lg:w-56 rounded rounded p-2 shadow text-white mb-5`}>
       <h4 className="text-lg mb-5">
         <HabitItem habit={habit}/>
       </h4>
       <div className="flex justify-between">
         <span>
           <small> {type === HABIT_TYPE.DO ? 'completed' : 'avoided'} </small>
         </span>
         <a href="#" onClick={handleUndo}>
           <small>undo</small>
         </a>
       </div>
     </div>
   )
}

HabitCard.defaultProps = {
  habit: {
    completed: false, 
    name: 'No Title',
    color: 'red-400',
    type: HABIT_TYPE.DO
  }
}

HabitCard.propTypes = {
  habit: shape({
    id: number,
    name: any,
    completed: bool,
    color: string, 
    uuid: string,
    type: oneOfType([HABIT_TYPE.DO, HABIT_TYPE.DONT]),
    recurrence: arrayOf(number), 
  }),
  onMarkComplete: func,
  onUndoComplete: func,
}
